import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export class ReservationSlotSettingsController {
  static getAllNewSlotStatus = async ({
    type,
    reservationSettingsId,
    reservationDate,
    resolve,
    reject,
  }) => {
    const errorMessage =
      "Unable to get all new reservation slot status details.\nPlease contact administrator for assistance.";
    try {
      const data = await getDocs(
        query(
          collection(db, type),
          where("reservationDate", "==", reservationDate),
          where("reservationSettingsId", "==", reservationSettingsId)
        )
      );
      resolve(data);
    } catch (error) {
      reject(
        this.errorHandling({
          errorMessage,
          error,
        })
      );
    }
  };

  static getNewSlotStatus = async ({
    type,
    reservationSettingsId,
    reservationDate,
    timeSlotsId,
    resolve,
    reject,
  }) => {
    const errorMessage =
      "Unable to get new reservation slot status details.\nPlease contact administrator for assistance.";
    try {
      const snapshot = await getDocs(
        query(
          collection(db, type),
          where("reservationDate", "==", reservationDate),
          where("reservationSettingsId", "==", reservationSettingsId),
          where("timeSlot.id", "==", timeSlotsId)
        )
      );
      if (snapshot.empty) {
        resolve(null);
        return;
      }
      const docData = snapshot.docs[0].data();
      resolve(docData?.timeSlot?.newSlotStatus || null);
    } catch (error) {
      reject(
        this.errorHandling({
          errorMessage,
          error,
        })
      );
    }
  };

  static upsert = async ({ type, parameters, resolve, reject }) => {
    const errorMessage =
      "Unable to save reservation slot settings details.\nPlease contact administrator for assistance.";
    try {
      const snapshot = await getDocs(
        query(
          collection(db, type),
          where("reservationDate", "==", parameters.reservationDate),
          where(
            "reservationSettingsId",
            "==",
            parameters.reservationSettingsId
          ),
          where("timeSlot.id", "==", parameters.timeSlot.id)
        )
      );
      if (!snapshot.empty) {
        const docRef = snapshot.docs[0].ref;
        await updateDoc(docRef, parameters);
        resolve("Slot Status updated successfully.");
      } else {
        await addDoc(collection(db, type), parameters);
        resolve("Slot Status added successfully.");
      }
    } catch (error) {
      reject(this.errorHandling({ errorMessage: errorMessage, error: error }));
    }
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
